import { ServerNotification, NotificationsResponse, GetNotificationsFn, NotificationAction } from "../../../rest/notifications";
import { appNavigator } from "../../routes";

// NotificationCenter incapsulates the interaction with browser's notification API
export class NotificationCenter
{
    private readonly handlers = new Map<string, () => void>();
    private running = false;
    private token: any;
    
    constructor(private getNotifications: GetNotificationsFn, private pullTimeoutMS: number)
    {
    }

    addActionHandler(key: NotificationAction, handler: () => void)
    {
        this.handlers.set(key, handler);
    }

    // start to pull server about important events like undefined alert levels
    start()
    {
        if(!this.running && this.getCurrentPermission() !== 'denied') {
            Notification.requestPermission().then(result => {
                if(result == 'granted') {
                    this.running = true;
                    this.pull();
                    this.token = setInterval(this.pull, this.pullTimeoutMS);
                }
            });
        }
    }

    stop()
    {
        if(this.running) {
            this.running = false;
            clearInterval(this.token);
        }
    }

    pull = () => {
        this.getNotifications()
            .then(resp => this.handleNotifications(resp.Notifications))
            .catch(err => console.error(err));
    }

    // this lambda invokes callbacks when user interacts with native notification
    handleNotifications = (notifications: ServerNotification[]) => {
        if(notifications && notifications.length > 0) {
            let i = 0;
            // Using an interval cause some browsers are blocking notifications if there are too much in a certain time.
            // https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API/Using_the_Notifications_API
            let token: any = setInterval(() => {
                if(i === notifications.length) {
                    clearInterval(token);
                    return;
                }
                const { Title: title, Message: message, Action: action } = notifications[i++];
                let n = new Notification(title, { body: message, icon: 'http://www.valortpms.com/sites/all/themes/valor/logo.png' });
                n.addEventListener('click', e => {
                    window.focus();
                    n.close();
                    
                    const handler = this.handlers.get(action);
                    handler && handler();
                })
            }, 200);
        }
    }

    // TODO: wrong type defenition https://github.com/Microsoft/TypeScript/issues/14701
    getCurrentPermission = (): NotificationPermission => (Notification as any).permission;
}


// WEBPACK FOOTER //
// ./src/app/utils/Notifications/NotificationCenter.ts